import { get, post } from 'common/apiClient';
import React from 'react';

export type FilterPayload = {
  isExtract?: boolean;
  PageSize?: any;
  PageNo?: any;
  Username?: string;
  LANumber?: string;
  merchantId?: string;
  orderId?: string;
  paymentPurpose?: string;
  fromDate?: string;
  paymentReferenceNo?: string;
  PaymentRequestId?: string;
  toDate?: string;
  SourceApplicationName?: string;
};

export type AgentPagedResponse = {
  data: AgentPagedList;
};

export type AgentPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: AgentListData[];
};

export type ApplicantDetailsResponse = {
  data: ApplicantDetails[];
};

export type CreateLinkResponse = {
  data: LinkModel;
};

export type FeesDetails = {
  feesList?: JSX.Element;
  key: React.Key;
  feeDesc: string | undefined;
  feeCode: string | undefined;
  amount: number;
  updatedAmount?: number;
  active: boolean;
};

export type FeesRespose = {
  data: FeesDetails[];
};

export type FeeCodes = {
  id?: string;
  feeCode?: string;
  feeDescription?: string;
  label?: string;
  value?: string;
};

export type FeeCodesResponse = {
  data: FeeCodes[];
};

export type SystemDate = {
  data: Date;
};

export type LinkModel = {
  shortLink: string;
  paymentRequestId: number;
  refTransaction: string;
};

export type AgentPayload = {
  id: string;
  email: string;
  isConfirmed: boolean;
};

export type AgentListData = {
  PaymentRequestId: number;
  LoanNumber: string;
  Amount: number;
  ShortLink: string;
  PAYMENTPURPOSE: string;
  EmailTo: string;
  Email_ApplicantType: string;
  EmailID: string;
  EmailSentDate: string;
  EmailStatus: string;
  SMSTo: string;
  SMS_ApplicantType: string;
  ContactNo: number;
  SMSSentDate: string;
  SMSStatus: string;
  ByAgent: string;
  VerificationReason: string;
  AgentRejectRemarks: string;
};

export type LinkPayload = {
  loanNumber?: string;
  paymentPurpose?: string;
  partnerId?: number;
  amount?: number;
  srNo?: string;
  mode?: string;
  ifsc?: string;
  micr?: string;
  chequeNo?: string;
  favourName?: string;
  valueDate?: Date;
  remark?: string;
  email?: string;
  mobileNo?: string;
};

export type CreateLinkPayload = {
  sourceId?: string;
  receipents?: ApplicantDetails[];
  amount?: number;
  loanType?: string;
  crmSrNo?: any;
  laNumber?: string;
  token?: string;
  sessionId?: string;
  feeType?: any;
  userId?: number;
  mode?: string;
  feesList?: FeesDetails[];
  requestPurpose?: string;
  paymentPurpose?: string;
  ifscCode?: string;
  micrCode?: string;
  chequeNo?: string;
  favourName?: string;
  valueDate?: string;
  remark?: string;
  customerName?: string;
  emailId?: string;
  mobileNo?: string;
  cif?: string;
  allowedAmount?: string;
  totalAmount?: string;
  pennantDate?: string;
  foreclosureRequestDate?: string | null;
  foreclosureIssuanceDate?: string | null;
};
export type ApplicantDetails = {
  key: React.Key;
  loanType: string | undefined;
  eMISiPiAmount: string | undefined;
  overdueAmount: string | undefined;
  totalAmount: string | undefined;
  currentMonthINST: string | undefined;
  allowedAmount: string | undefined;
  accountName?: string | undefined;
  mobileNumber?: string | undefined;
  customerName?: string | undefined;
  loanBranch: string | undefined;
  emailId?: string | undefined;
  cIFId?: string | undefined;
};

export type FeesPayload = {
  loanNo: string;
  feeType: string;
  days?: string;
};

export type BulkLinkPayload = {
  loanList: string[];
  linkList: CreateLinkPayload[];
  applicantType: number;
  partnerId: number;
};

export type ReportPayload = {
  userId?: number;
  partnerId?: number;
  reportDate?: String;
  isExtract?: boolean;
  type?: number;
};

export type PascalCaseBulkUpload = {
  FileName: string;
  TotalRecord: number;
  BulkUploadRequestList: PascalCaseBulkUploadRequest[];
  UserEmailId?: string;
  PartnerId?: number;
  SourceId?: string;
};

export type PascalCaseBulkUploadRequest = {
  LoanNumber?: string;
  PaymentPurpose?: string;
  Amount?: number;
  AccountName?: string;
  EmailId?: string;
  MobileNo?: string;
  ApplicantType?: string;
  Status?: string;
  ErrorMessage?: string;
  CreatedDate?: string;
};

export type CamelCaseBulkUpload = {
  key?: React.Key;
  fileName: string;
  totalRecord: number;
  bulkUploadRecordList: CamelCaseBulkUploadRecord[];
  userEmailId?: string;
  partnerId?: number;
  sourceId?: string;
  createdBy?: number;
};

export type CamelCaseBulkUploadRecord = {
  key?: React.Key;
  loanNumber?: string;
  paymentPurpose?: string;
  recordId?: number;
};

export const getAgentList = (payload?: FilterPayload) =>
  post<AgentPagedResponse>('/dashboardmodule/getAgentLinkDashboard', payload);

export const getApplicantDetails = (payload?: LinkPayload) =>
  post<ApplicantDetailsResponse>('/agentmodule/getApplicantDetails', payload);

export const getFeesChargeDetails = (payload?: FeesPayload) =>
  post<FeesRespose>('/agentmodule/getFeeCharges', payload);

export const getFeesCodes = () => get<FeeCodesResponse>('/agentmodule/getFeeCodeDetails');

export const createLink = (payload?: CreateLinkPayload) =>
  post<CreateLinkResponse>('/agentmodule/agentLinkProcessing', payload);

export const createReceipt = (payload?: CreateLinkPayload) =>
  post<CreateLinkResponse>('/agentmodule/agentReceiptProcessing', payload);

export const createLinkBulk = (payload?: CreateLinkPayload) =>
  post<any>('/agentmodule/agentLinkProcessing', payload, true);

export const bulkLink = (payload?: BulkLinkPayload) =>
  post<any>('/agentmodule/bulkLinkProcessing', payload, true);

export const bulkSendReport = (payload?: ReportPayload) =>
  post<any>('/agentmodule/bulkSendReport', payload, true);

export const postBulkUplaod = (payload?: CamelCaseBulkUpload) =>
  post<any>('/agentmodule/bulkUpload', payload, true);

export const getBulkUplaodTemplate = () => get<CamelCaseBulkUpload[]>('/agentmodule/template');

export const getSystemDate = () => get<SystemDate>('/agentmodule/getSystemDate');
